import NavbarWithActions from "components/Navbar/navbarwithactions";
import { Outlet } from "react-router-dom";

export default function ForexOrderDetails() {
  return (
    <div className="flex flex-col h-full overflow-hidden gap-2.5 font-inter">
      <NavbarWithActions header="Order Details" />
      <div className="flex flex-col h-full overflow-x-auto overflow-y-auto w-full">

        <Outlet />
      </div>
    </div>
  );
}
